"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NDAOLogicV1__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "_setProposalThresholdBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "_setQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "_setVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cryptopunksVote",
        outputs: [
            {
                internalType: "contract CryptopunksVote",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct NDAOStorageV1.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "npunks_",
                type: "address",
            },
            {
                internalType: "address",
                name: "cryptopunksVote_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThresholdBPS_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotesBPS_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "npunks",
        outputs: [
            {
                internalType: "contract NTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "vetoed",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum NDAOStorageV1.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract IDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NDAOLogicV1__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NDAOLogicV1__factory = NDAOLogicV1__factory;
NDAOLogicV1__factory.bytecode = _bytecode;
NDAOLogicV1__factory.abi = _abi;
